import { WPETypeFile } from "./file/WPETypeFile";
import { WPETypeToDoList } from "./list/WPETypeToDoList";

export const WPEMap = {
  file: WPETypeFile,
  list: WPETypeToDoList,
};
